import { render, staticRenderFns } from "./AiSuggestBar.vue?vue&type=template&id=217ab3e6&scoped=true&"
import script from "./AiSuggestBar.vue?vue&type=script&lang=js&"
export * from "./AiSuggestBar.vue?vue&type=script&lang=js&"
import style0 from "./AiSuggestBar.vue?vue&type=style&index=0&id=217ab3e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ab3e6",
  null
  
)

export default component.exports